'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _addToCartAmount = require('../components/add-to-cart-amount');

var _addToCartAmount2 = _interopRequireDefault(_addToCartAmount);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _has = require('lodash/has');

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddToCartAmountContainer = function (_React$Component) {
    (0, _inherits3.default)(AddToCartAmountContainer, _React$Component);

    function AddToCartAmountContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AddToCartAmountContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddToCartAmountContainer.__proto__ || (0, _getPrototypeOf2.default)(AddToCartAmountContainer)).call.apply(_ref, [this].concat(args))), _this), _this.handleBlur = function (e) {
            _this.props.getSummaryForProducts();
        }, _this.handleChange = function (e) {
            console.log(e.target.value ? e.target.value : 0);

            _this.props.massChangeAmount({
                productId: _this.props.productId,
                amount: e.target.value ? e.target.value : 0,
                catalogId: _this.props.catalogId
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AddToCartAmountContainer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_addToCartAmount2.default, (0, _extends3.default)({ onChange: this.handleChange,
                onBlur: this.handleBlur,
                canChangeCart: this.canChangeCart
            }, this.props));
        }
    }]);
    return AddToCartAmountContainer;
}(_react2.default.Component);

AddToCartAmountContainer.propTypes = {
    amount: _react2.default.PropTypes.number,
    displayAmount: _react2.default.PropTypes.string,
    productId: _react2.default.PropTypes.number.isRequired,
    hasChanged: _react2.default.PropTypes.bool.isRequired,
    amountAvailable: _react2.default.PropTypes.number,
    totalAmountAvailable: _react2.default.PropTypes.number,
    massChangeAmount: _react2.default.PropTypes.func.isRequired,
    submitChanges: _react2.default.PropTypes.func.isRequired,
    processing: _react2.default.PropTypes.bool.isRequired,
    getSummaryForProducts: _react2.default.PropTypes.func.isRequired,
    catalogId: _react2.default.PropTypes.number
};

function mapStateToProps(state, ownProps) {
    var productId = ownProps.productId,
        customerId = ownProps.customerId,
        amount = ownProps.amount,
        catalogId = ownProps.catalogId,
        _ownProps$amountAvail = ownProps.amountAvailable,
        amountAvailable = _ownProps$amountAvail === undefined ? 0 : _ownProps$amountAvail,
        _ownProps$totalAmount = ownProps.totalAmountAvailable,
        totalAmountAvailable = _ownProps$totalAmount === undefined ? 0 : _ownProps$totalAmount;

    var props = {
        productId: productId,
        customerId: customerId,
        amount: null,
        amountAvailable: amountAvailable,
        totalAmountAvailable: totalAmountAvailable,
        catalogId: catalogId,
        origAmount: amount,
        hasChanged: false,
        canChangeCart: state.cart.canChangeCart,
        processing: state.cart.processing
    };
    var changed = state.cart.changes[(0, _linksoftAlbatros.getCartChangeKey)(props)];
    if (changed) {
        props.hasChanged = true;
        props.amount = changed.amount;
        props.displayAmount = changed.displayAmount;
    } else if (customerId) {
        var propPath = 'customerSpecific[' + productId + '][' + customerId + ']';
        props.amount = (0, _has2.default)(state.cart, propPath) ? (0, _get3.default)(state.cart, propPath) : amount;
        props.displayAmount = props.amount > 0 ? props.amount + '' : '';
    } else {
        var updatingItem = state.cart.updating[productId];
        if (updatingItem) {
            props.displayAmount = updatingItem.displayAmount;
        } else {
            var item = state.cart.itemAmounts.find(function (i) {
                return i.productId === productId;
            });
            if (item) {
                props.amount = item.amount;
                props.displayAmount = props.amount > 0 ? props.amount + '' : '';
            }
        }
    }
    return props;
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    massChangeAmount: _actions2.default.massChangeAmount,
    submitChanges: _actions2.default.submitChanges,
    getSummaryForProducts: _actions2.default.getSummaryForProducts
})(AddToCartAmountContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/add-to-cart-amount.js
// module id = 1147
// module chunks = 0